<template>
  <div class="userCreate">
    <v-sheet class="my-5 d-md-flex">
      <v-sheet class="flex-sm-column">
        <p class="text-h4">{{ id ? "Edit User" : "Create User" }}</p>
      </v-sheet>

      <v-sheet class="flex-sm-column">
        <v-breadcrumbs class="pa-md-3 pa-0 mb-4 ">
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
            User
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'userCreate', params: {} }">
            Create User
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-sheet>
    </v-sheet>

    <user-form></user-form>
  </div>
</template>
<script>
import UserForm from "./UserFormNew.vue";

export default {
  name: "user",
  components: {
    UserForm,
  },
  created() {
    this.$emit("showParent", false);
  },
};
</script>
